import { postData } from '../utils/api';

/**
 * Gửi thông tin contact tới backend
 * @param {Object} contactData 
 * @returns {Promise}
 */
export const sendContactEmail = (contactData) => {
  return postData('api/contact', contactData);
};
